"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.batchUpdateAbExposure = exports.ExposureServiceBatchUpdateAbExposureDesc = exports.AbExposureData = exports.LoggingType = exports.GeoData = exports.Properties = exports.IdType = exports.Id = exports.UpdateAbExposureResponse = exports.BatchUpdateAbExposureRequest = void 0;
const exposure_service_1 = require("../generated/ab_service/exposure_service");
Object.defineProperty(exports, "BatchUpdateAbExposureRequest", { enumerable: true, get: function () { return exposure_service_1.BatchUpdateAbExposureRequest; } });
Object.defineProperty(exports, "GeoData", { enumerable: true, get: function () { return exposure_service_1.GeoData; } });
Object.defineProperty(exports, "Id", { enumerable: true, get: function () { return exposure_service_1.Id; } });
Object.defineProperty(exports, "IdType", { enumerable: true, get: function () { return exposure_service_1.IdType; } });
Object.defineProperty(exports, "LoggingType", { enumerable: true, get: function () { return exposure_service_1.LoggingType; } });
Object.defineProperty(exports, "Properties", { enumerable: true, get: function () { return exposure_service_1.Properties; } });
Object.defineProperty(exports, "UpdateAbExposureResponse", { enumerable: true, get: function () { return exposure_service_1.UpdateAbExposureResponse; } });
Object.defineProperty(exports, "AbExposureData", { enumerable: true, get: function () { return exposure_service_1.AbExposureData; } });
exports.ExposureServiceBatchUpdateAbExposureDesc = {
    methodName: "BatchUpdateAbExposure",
    service: {
        serviceName: "snapchat.ab.exposure_service.ExposureService",
    },
    requestStream: false,
    responseStream: false,
    requestType: {
        serializeBinary() {
            return exposure_service_1.BatchUpdateAbExposureRequest.encode(this).finish();
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
    },
    responseType: {
        deserializeBinary(data) {
            return Object.assign(Object.assign({}, exposure_service_1.BatchUpdateAbExposureResponse.decode(data)), { toObject() {
                    return this;
                } });
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
    },
};
/**
 * Logs a batch of A/B exposures.
 * Wrapper around https://github.sc-corp.net/Snapchat/pb_schema/blob/aada2286467319341cec0759f6d8e7d45e1b0307/proto/ab_service/exposure_service.proto#L16
 *
 * @param client Client object that is returned by calling initConfigsClient().
 * @param request Request object.
 * @param metadata Optional metadata.
 */
function batchUpdateAbExposure(client, request, metadata) {
    return client.rpc.unary(exports.ExposureServiceBatchUpdateAbExposureDesc, exposure_service_1.BatchUpdateAbExposureRequest.fromPartial(request), metadata);
}
exports.batchUpdateAbExposure = batchUpdateAbExposure;
//# sourceMappingURL=batchUpdateAbExposure.js.map